import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrow1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M2.97 11.47a.75.75 0 0 0 0 1.06l6.07 6.07a.75.75 0 1 0 1.06-1.06l-4.79-4.79H20.5a.75.75 0 1 0 0-1.5H5.31l4.79-4.79A.75.75 0 1 0 9.04 5.4l-6.07 6.07Z"
      clipRule="evenodd"
    />
    <path
      fill="#A5A5AA"
      d="m2.97 11.47.176.176-.176-.176Zm0 1.06.176-.176-.176.176Zm6.07 6.07.176-.177-.176.177Zm1.06 0 .177.177-.177-.177Zm0-1.06.177-.177-.177.177Zm-4.79-4.79v-.25a.25.25 0 0 0-.176.427l.177-.177Zm15.19 0v-.25.25Zm0-1.5V11v.25Zm-15.19 0-.176-.177a.25.25 0 0 0 .177.427v-.25Zm4.79-4.79-.176-.176.176.176Zm0-1.06-.176.176.176-.176Zm-1.06 0 .176.176L9.04 5.4ZM3 12a.5.5 0 0 1 .146-.354l-.353-.353A1 1 0 0 0 2.5 12H3Zm.146.354A.5.5 0 0 1 3 12h-.5a1 1 0 0 0 .293.707l.353-.354Zm6.07 6.07-6.07-6.07-.353.353 6.07 6.07.353-.354Zm.708 0a.5.5 0 0 1-.708 0l-.353.353a1 1 0 0 0 1.414 0l-.353-.354Zm0-.708a.5.5 0 0 1 0 .707l.353.354a1 1 0 0 0 0-1.414l-.353.353Zm-4.79-4.79 4.79 4.79.353-.353-4.79-4.79-.353.354ZM20.5 12.5H5.31v.5H20.5v-.5Zm.5-.5a.5.5 0 0 1-.5.5v.5a1 1 0 0 0 1-1H21Zm-.5-.5a.5.5 0 0 1 .5.5h.5a1 1 0 0 0-1-1v.5Zm-15.19 0H20.5V11H5.31v.5Zm4.614-5.216-4.79 4.79.353.353 4.79-4.79-.353-.353Zm0-.708a.5.5 0 0 1 0 .708l.353.353a1 1 0 0 0 0-1.414l-.353.353Zm-.708 0a.5.5 0 0 1 .708 0l.353-.353a1 1 0 0 0-1.414 0l.353.353Zm-6.07 6.07 6.07-6.07-.353-.353-6.07 6.07.353.353Z"
    />
  </svg>
);
export default SvgArrow1;
